import PropTypes from 'prop-types'

export const COLS = 12 // количество колонок. Если меняем тут, то и в файле /src/mixins/_flex.scss

export const ColumnSizeType = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.bool,
  PropTypes.string,
])

export const SIZES = [
  // если тут добавляем новый размер, то и в файле scss тоже добавляем
  // /src/components/variables/breakpoints.scss
  's',
  'xs',
  'sm',
  'fb',
  'md',
  'lg',
  'mds',
  'l',
  'ls',
  'xl',
  'xxl',
]

export const ViewportSizeType = PropTypes.oneOf(SIZES)

export const ContainerSizeType = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.bool,
  ViewportSizeType,
])

export const AlignContentType = PropTypes.oneOf([
  'start',
  'end',
  'center',
  'between',
  'around',
  'stretch',
])

export const AlignSelfType = PropTypes.oneOf([
  'start',
  'end',
  'center',
  'stretch',
])

export const AlignItemsType = PropTypes.oneOf([
  'start',
  'end',
  'center',
  'baseline',
  'stretch',
  'flex-start',
  'flex-end',
  'space-between',
  'space-around',
  'space-evenly',
])
export const JustifyContentType = PropTypes.oneOf([
  'start',
  'end',
  'center',
  'between',
  'around',
  'evenly',
  'flex-start',
  'flex-end',
  'space-between',
  'space-around',
  'space-evenly',
])

export const WrapType = PropTypes.oneOfType([
  PropTypes.bool,
  PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
])

export const FlexDirectionType = PropTypes.oneOf([
  'column',
  'row',
  'column-reverse',
  'row-reverse',
])

export const TextAlignType = PropTypes.oneOf(['left', 'center', 'right'])

export const DisplayType = PropTypes.oneOf([
  'block',
  'inline',
  'inline-block',
  'flex',
  'inline-flex',
  'table',
  'table-row',
  'table-cell',
  'none',
])

export const VAlignType = PropTypes.oneOf([
  'baseline',
  'bottom',
  'middle',
  'sub',
  'super',
  'text-bottom',
  'text-top',
  'top',
  'inherit',
])

export const ColsType = PropTypes.oneOf([
  'auto',
  ...Array.from({ length: COLS }, (_, i) => i + 1),
])
